<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="jobBoard">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.components.job-board-settings.logo' | appTranslate }}</mat-label>
                <ui-mat-file-upload
                    #logo
                    [(ngModel)]="jobBoard.logoFile"
                    [allowedTypes]="allowedFileTypes"
                    name="logo"
                ></ui-mat-file-upload>
                <ui-button type="outline">{{
                    'applicant-tracker.components.job-board-settings.browse' | appTranslate
                }}</ui-button>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field>
                <mat-label>{{
                    'applicant-tracker.components.job-board-settings.buttonColor' | appTranslate
                }}</mat-label>
                <ui-color-picker
                    #buttonColor="ngModel"
                    [placeholder]="'#000000'"
                    name="buttonColor"
                    [(ngModel)]="jobBoard.buttonColor"
                ></ui-color-picker>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{
                    'applicant-tracker.components.job-board-settings.headerColor' | appTranslate
                }}</mat-label>
                <ui-color-picker
                    #pageColor="ngModel"
                    [placeholder]="'#000000'"
                    name="pageColor"
                    [(ngModel)]="jobBoard.pageColor"
                ></ui-color-picker>
            </mat-form-field>
        </div>
    </ng-container>
</form>
